import React from "react";
import { Box, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DATE_FORMAT } from "utils/helper";

const EligibilityHeader = ({ dos, setDos }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      sx={{ backgroundColor: "white" }}
    >
      <Typography variant="h3" fontSize={18} fontWeight={500}>
        Patient Eligibilities
      </Typography>
      <DesktopDatePicker
        placeholder={DATE_FORMAT}
        format={DATE_FORMAT}
        value={dayjs(dos)}
        onChange={(e) => setDos(e)}
        slotProps={{
          textField: {
            variant: "standard",
            label: "DOS",
            InputLabelProps: {
              sx: {
                color: "#d91a5f",
                fontWeight: "bold",
                fontSize: "18px",
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default EligibilityHeader;
